import React from 'react'
import ExpandablePanel from '../controls/ExpandablePanel'
import KasKrsV12 from '../KasKrsV12'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import ChipInput from 'material-ui-chip-input'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { controlHasError } from '../../lib/errorHandler'
import {
  FORMA_PRAWNA_INNA_KOD,
  FORMA_PRAWNA_OPTIONS,
} from '../../lib/formaPrawnaOptions'

class IdentyfikacjaPodmiotuR2 extends React.Component {
  handleAddChip = (chip) => {
    const { data, onSetSectionData } = this.props
    const newPKD = [...data.PKD, chip]
    onSetSectionData('PKD', newPKD)
  }

  handleDeleteChip = (chip, index) => {
    const { data, onSetSectionData } = this.props
    const newPKD = [...data.PKD]
    newPKD.splice(index, 1)
    onSetSectionData('PKD', newPKD)
  }

  handleFormaPrawnaChange = ({ target: { value } }) => {
    const { onSetSectionData } = this.props
    onSetSectionData('FormaPrawnaKod', value)
    if (value !== FORMA_PRAWNA_INNA_KOD) {
      onSetSectionData('FormaPrawnaInnaOpis', '')
    }
  }

  render() {
    const { errors, data, onSetSectionData, onLoadGUS, onSetName } = this.props
    const formaPrawnaKod = data.FormaPrawnaKod || ''
    const pokazInnaForma = formaPrawnaKod === FORMA_PRAWNA_INNA_KOD

    return (
      <ExpandablePanel title="IDENTYFIKACJA PODMIOTU">
        <form
          name="IdentyfikacjaPodmiotuV12"
          autoComplete="off"
          className="identyfikacjaPodmiotu"
        >
          <KasKrsV12
            className="kasKrs"
            hasError={(name) => controlHasError(errors, name)}
            data={{
              NrNIP: data.NrNIP || '',
              NrKRS: data.NrKRS || '',
            }}
            onSetSectionData={(e) => {
              onSetSectionData(e.target.name, e.target.value)
            }}
            onLoadGUS={onLoadGUS}
          />
          <FormControl component="fieldset" className="nazwa">
            <TextField
              error={controlHasError(errors, 'NazwaFirmy')}
              name="NazwaFirmy"
              label="Nazwa pełna"
              title={data.NazwaFirmy}
              value={data.NazwaFirmy}
              onChange={(e) => {
                onSetSectionData(e.target.name, e.target.value)
                onSetName(e.target.value)
              }}
            />
          </FormControl>
          <div className='formaPrawnaRow'>
            <FormControl component='fieldset' className='formaPrawna'>
              <InputLabel>Forma prawna jednostki</InputLabel>
              <Select
                error={controlHasError(errors, 'FormaPrawnaKod')}
                name='FormaPrawnaKod'
                value={formaPrawnaKod}
                onChange={this.handleFormaPrawnaChange}
              >
                {FORMA_PRAWNA_OPTIONS.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {pokazInnaForma ? (
              <FormControl component='fieldset' className='formaPrawnaInna'>
                <TextField
                  error={controlHasError(errors, 'FormaPrawnaInnaOpis')}
                  name='FormaPrawnaInnaOpis'
                  label='Opis innej formy prawnej jednostki'
                  title={data.FormaPrawnaInnaOpis}
                  value={data.FormaPrawnaInnaOpis}
                  onChange={(e) =>
                    onSetSectionData(e.target.name, e.target.value)
                  }
                />
              </FormControl>
            ) : null}
          </div>          
          <FormControl component="fieldset" className="pkd">
            <ChipInput
              error={controlHasError(errors, 'PKD')}
              InputLabelProps={{ shrink: true }}
              name="PKD"
              label="Kody PKD"
              placeholder="Wpisz kod + [ENTER]"
              value={data.PKD}
              onAdd={this.handleAddChip}
              onDelete={this.handleDeleteChip}
              helperText="Pojedynczy kod: 5 znaków, bez kropek"
            />
          </FormControl>
        </form>
      </ExpandablePanel>
    )
  }
}

export default IdentyfikacjaPodmiotuR2
